import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const listContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.08 } },
};
export const listItem = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] } },
};
const checkPop = {
  hidden: { scale: 0, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { type: "spring", stiffness: 480, damping: 16 } },
};

const viewport = { once: true, amount: 0.35 };

export function CheckList({ items, className = "", itemClass = "text-slate-700", circleClass = "bg-emerald-500 text-white" }) {
  return (
    <motion.ul variants={listContainer} initial="hidden" whileInView="show" viewport={viewport} className={className}>
      {items.map((t, i) => (
        <motion.li key={i} variants={listItem} className={`flex items-start gap-2.5 ${itemClass}`}>
          <motion.span variants={checkPop} className={`mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${circleClass}`}>
            <Check className="h-3 w-3" strokeWidth={3} />
          </motion.span>
          <span>{t}</span>
        </motion.li>
      ))}
    </motion.ul>
  );
}

export function StepList({ steps, badgeClass = "bg-[#263871]" }) {
  return (
    <motion.ol variants={listContainer} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.25 }} className="mt-5 space-y-4">
      {steps.map((s, i) => (
        <motion.li key={i} variants={listItem} className="flex gap-3">
          <motion.span variants={checkPop} className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${badgeClass} text-xs font-bold text-white`}>{i + 1}</motion.span>
          <span className="text-sm text-slate-700">{s}</span>
        </motion.li>
      ))}
    </motion.ol>
  );
}
